import {useSessionExpired} from "../../contexts/SessionExpiredContext";
import {setIsValidOutsideReact} from "../../contexts/AuthContext";
import {useEffect} from "react";
import {Modal} from "antd";



const SessionExpiry = () => {
    const { openSessionModal, setOpenSessionModal } = useSessionExpired();

    useEffect(() => {
        const interval = setInterval(() => {
            const expires = localStorage.getItem("session_expires");

            if (expires && Date.now() >= Number(expires)) {
                localStorage.removeItem("session_expires");
            }
        }, 5 * 60 * 1000);

        return () => clearInterval(interval);
    }, [setOpenSessionModal]);

    const onCloseModal = () => {
        setIsValidOutsideReact(false);
        setOpenSessionModal(false);
    };

    return (
        <Modal
            title="Warning"
            open={openSessionModal}
            onOk={onCloseModal}
            onCancel={onCloseModal}
        >
            <p>Your session is no longer valid. Please log in again....</p>
        </Modal>
    );
};

export default SessionExpiry;


